import type { MeetingPageTemplate } from '@wundo/shared/meetingPage.ts';
import type { MeetingTemplateItem } from '@wundo/shared/meetingTemplate.ts';

/** A gesprekstype as a menu or a dropdown offers it. */
export type MeetingTypeOption = Pick<MeetingTemplateItem, 'id' | 'name' | 'color'>;

/**
 * The gesprekstypes this user may pick, with the one the meeting follows now
 * up front when the list lacks it: aimed at another cohort since it was chosen,
 * it is no longer offered, but it is still this meeting's.
 */
export function withCurrentTemplate(
  templates: MeetingTypeOption[],
  current: MeetingPageTemplate | null,
): MeetingTypeOption[] {
  const id = current?.id;
  if (!current || !id || templates.some((template) => template.id === id)) {
    return templates;
  }

  return [{ id, name: current.name, color: current.color }, ...templates];
}
